import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import { Bookmark } from "../../types/app";

export interface BookmarkState {
  bookmarksLoaded: boolean;
  bookmarkDialogOpen: boolean;
  bookmarkDeleteTracker: number;
  currSelectedBookmarkTitle: string;
  currSelectedBookmarkGroup: string;
  preUploadedBookmarks: Bookmark[];
  bookmarks: Bookmark[];
  colorMapping: { [key: string]: string };
}

const initialState: BookmarkState = {
  bookmarksLoaded: false,
  bookmarkDialogOpen: false,
  bookmarkDeleteTracker: 0,
  currSelectedBookmarkTitle: "",
  currSelectedBookmarkGroup: "",
  preUploadedBookmarks: [],
  bookmarks: [],
  colorMapping: {},
};

export const bookmarkResetAll = createAction("RESET_ALL");

export const bookmarkSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setBookmarkLoaded: (state) => {
      state.bookmarksLoaded = true;
    },
    setBookmarkDialogState: (state, action: PayloadAction<boolean>) => {
      state.bookmarkDialogOpen = action.payload;
    },
    setBookmarkDeleteTracker: (state) => {
      state.bookmarkDeleteTracker += 1;
    },
    setPreUploadedBookmarks: (state, action: PayloadAction<Bookmark[]>) => {
      state.preUploadedBookmarks = action.payload;
    },
    setCurrentSelectedBookmarks: (
      state,
      action: PayloadAction<{ title: string; group: string }>
    ) => {
      state.currSelectedBookmarkTitle = action.payload.title;
      state.currSelectedBookmarkGroup = action.payload.group;
    },
    setBookmarks: (state, action: PayloadAction<Bookmark[]>) => {
      state.bookmarks = action.payload;
    },
    setBookmarkColorMapping: (
      state,
      action: PayloadAction<{ [key: string]: string }>
    ) => {
      state.colorMapping = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(bookmarkResetAll, () => initialState);
  },
});

export const {
  setBookmarkLoaded,
  setBookmarkDialogState,
  setBookmarkDeleteTracker,
  setPreUploadedBookmarks,
  setCurrentSelectedBookmarks,
  setBookmarks,
  setBookmarkColorMapping,
} = bookmarkSlice.actions;

export default bookmarkSlice.reducer;
